import React, { createContext, useState, useEffect, useCallback, useMemo } from 'react'

import api from '../services/api'

export const BusinessContext = createContext({})

function BusinessProvider({ children }) {

  const [business, setBusiness] = useState(JSON.parse(localStorage.getItem("business")) || {})
  const [encodedBusinessId, setEncodedBusinessId] = useState(JSON.parse(localStorage.getItem("encodedBusinessId")))

  useEffect(() => {
    localStorage.setItem('business', JSON.stringify(business))
  }, [business])

  useEffect(() => {
    localStorage.setItem('encodedBusinessId', JSON.stringify(encodedBusinessId))
  }, [encodedBusinessId])

  // useCallback com deps vazias: a funcao nao fecha sobre nada do render.
  // Sem isso ela muda de identidade a cada render, e como `BusinessData` a
  // tem como dependencia de efeito, o efeito reexecutava, chamava a API,
  // trocava `business`, re-renderizava o provider — laco infinito.
  const getBusiness = useCallback(async (businessId) => {

    try {

      const response = await api.get(`businesses/${businessId}`)

      setBusiness(response.data)

    //  localStorage.setItem("business", JSON.stringify(response.data));

    } catch (error) {
      if (error.response) {
        alert(error.response.data.error)
        console.log(error.response.data.error)
      } else {
        console.log(error.message)
        alert(error.message)
      }
    }
  }, [])


  // O objeto literal tambem era recriado a cada render, invalidando todos os
  // consumidores mesmo quando nada mudava.
  const value = useMemo(
    () => ({ business, getBusiness, encodedBusinessId, setEncodedBusinessId }),
    [business, getBusiness, encodedBusinessId]
  )

  return (
    <BusinessContext.Provider value={value}>
      {children}
    </BusinessContext.Provider>
  )
}

export default BusinessProvider
